import React, { useState, useEffect, useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import Navbar from "../components/Navbar";
import Navbar2 from "../components/Navbar2";
import india from "../images/mainPage/india.png";
import girl from "../images/home/girl.png";
import NavbarMob from "../components/NavbarMob";
import vector from "../images/home/Vector.png";
import bulb from "../images/home/bulb.png";
import girloffice from "../images/home/girloffice.png";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Navbar3 from "../components/Navbar3";
import Navbar4 from "../components/Navbar4";
import Navbar5 from "../components/Navbar5";
import Navbar2Mob from "../components/Navbar2Mob";
import Navbar3Mob from "../components/Navbar3Mob";
import Navbar4Mob from "../components/Navbar4Mob";
import Navbar5Mob from "../components/Navbar5Mob";
import Select from "react-select";

function Home() {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const employeeId = sessionStorage.getItem("employeeId");
    const companyName = sessionStorage.getItem("customerName");
    const houseName = sessionStorage.getItem("houseName");
    const experienced = sessionStorage.getItem("experienced");

    const [loadingJobs, setLoadingJobs] = useState({});

    const customerType = sessionStorage.getItem("customerType");
    const selectedPlan = sessionStorage.getItem("selectedPlan");

    const District = sessionStorage.getItem("District");
    const mobileNumber = sessionStorage.getItem("mobileNumber");
    const whatsappNumber = sessionStorage.getItem("whatsappNumber");
    const Email = sessionStorage.getItem("Email");

    const navigate = useNavigate();

    const empreg2 = () => navigate("/empreg");
    const regchoose = () => navigate("/regchoose");
    const canreg2 = () => navigate("/canreg");

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    // ── Job Data & Pagination ─────────────────────
    const [allJobs, setAllJobs] = useState([]);
    const [visibleJobs, setVisibleJobs] = useState(100);

    // ── Search & Filter States ────────────────────
    const [searchTitle, setSearchTitle] = useState("");
    const [searchAddress, setSearchAddress] = useState("");

    // ── Fetch all enabled jobs ────────────────────
    useEffect(() => {
        fetch(`${apiBaseUrl}/getjobposts`)
            .then((response) => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                const enabledJobPosts = data.filter((job) => job.enable === "on");
                setAllJobs(enabledJobPosts);
            })
            .catch((error) => console.error("Error fetching job posts:", error));
    }, [apiBaseUrl]);

    const isWithinLast20Days = (createdAt) => {
        if (!createdAt) return false;

        const postedDate = new Date(createdAt);
        if (isNaN(postedDate.getTime())) return false;

        const now = new Date();
        const twentyDaysAgo = new Date(now);
        twentyDaysAgo.setDate(now.getDate() - 20);

        return postedDate >= twentyDaysAgo;
    };

    // ── Filtering logic ───────────────────────────
    const filteredJobs = useMemo(() => {
        // We no longer filter by date when no search is active
        // → show ALL jobs by default

        if (!searchTitle.trim() && !searchAddress.trim()) {
            return allJobs; // ← all jobs when no search
        }

        const needleTitle = searchTitle.trim().toLowerCase();
        const needleLoc = searchAddress.trim().toLowerCase();

        const filtered = allJobs.filter((job) => {
            // Job title/name partial substring match
            if (needleTitle) {
                const jobName = (job.job || "").toLowerCase();
                const jobTitle = (job.job_title || "").toLowerCase();
                if (!jobName.includes(needleTitle) && !jobTitle.includes(needleTitle)) return false;
            }

            // Location/address substring match (required when a location search is provided)
            if (needleLoc) {
                const loc = (job.location || "").toLowerCase();
                const addr = (job.address || "").toLowerCase();
                if (!loc.includes(needleLoc) && !addr.includes(needleLoc)) return false;
            }

            return true;
        });

        // Sort by relevance so the strongest location matches appear first
        return filtered.sort((a, b) => {
            const score = (job) => {
                let s = 0;
                if (needleLoc) {
                    const loc = (job.location || "").toLowerCase();
                    const addr = (job.address || "").toLowerCase();
                    if (loc === needleLoc || addr === needleLoc) s += 3; // exact match
                    else if (loc.startsWith(needleLoc) || addr.startsWith(needleLoc)) s += 2;
                    else if (loc.includes(needleLoc) || addr.includes(needleLoc)) s += 1;
                }
                if (needleTitle) {
                    const name = (job.job || "").toLowerCase();
                    const title = (job.job_title || "").toLowerCase();
                    if (name === needleTitle || title === needleTitle) s += 1.5;
                    else if (name.includes(needleTitle) || title.includes(needleTitle)) s += 1;
                }
                return s;
            };
            return score(b) - score(a);
        });
    }, [allJobs, searchTitle, searchAddress]);

    // Reset visible count when results change
    useEffect(() => {
        setVisibleJobs(100);
    }, [filteredJobs]);

    // Dynamic heading
    const sectionHeading = searchTitle.trim() || searchAddress.trim() ? "Matching Jobs Found" : "Latest Jobs";

    const jobsToShow = filteredJobs;

    // Posted date
    const getPostedTimeDisplay = (createdAt) => {
        if (!createdAt) return "-";

        const postedDate = new Date(createdAt);
        if (isNaN(postedDate.getTime())) return "-";

        const now = new Date();
        const twentyDaysAgo = new Date(now);
        twentyDaysAgo.setDate(now.getDate() - 20);

        // Only show exact date if job is within last 20 days
        if (postedDate >= twentyDaysAgo) {
            return postedDate.toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
            // → 22/01/2026
        }

        // For older jobs → show nothing, or "-", or "Older"
        return "-"; // cleanest option
        // return "Older";
        // return "";
    };

    const loadMoreJobs = () => {
        setVisibleJobs((prev) => prev + 100);
    };

    const details = (jobId) => {
        navigate("/details", { state: { jobId } });
    };

    const Packages2 = async (job) => {
        setLoadingJobs((prev) => ({ ...prev, [job.job_id]: true }));

        if (!customerType) {
            alert("Please login first");
            setLoadingJobs((prev) => ({ ...prev, [job.job_id]: false }));
            return;
        }

        if (["300", "500", "600", "800", "0"].includes(selectedPlan)) {
            try {
                const fetchEmployeeData = async () => {
                    try {
                        const response = await fetch(`${apiBaseUrl}/employee/${job.employee_id}`);
                        if (!response.ok) throw new Error();
                        const data = await response.json();
                        return {
                            additionalCompanyName: data.employee.company_name,
                            additionalMobileNumber: data.employee.mobile_number,
                            additionalLocation: data.employee.location,
                        };
                    } catch {
                        const fallbackResponse = await fetch(`${apiBaseUrl}/staff/${job.employee_id}`);
                        if (!fallbackResponse.ok) throw new Error();
                        const fallbackData = await fallbackResponse.json();
                        return {
                            additionalCompanyName: fallbackData.employee.companyName,
                            additionalMobileNumber: fallbackData.employee.mobileNumber,
                            additionalLocation: fallbackData.employee.address,
                        };
                    }
                };

                await fetchEmployeeData();

                const payload = {
                    employeeId: job.employee_id,
                    customerName: companyName,
                    houseName: houseName,
                    experienced: experienced,
                    jobId: job.job_id,
                    whatsappNumber: whatsappNumber,
                    mobileNumber: mobileNumber,
                    Email: Email,
                    additionalCompanyName: job.shopName,
                    additionalMobileNumber: job.whatsapp_number,
                    additionalLocation: job.location,
                };

                const currentDate = new Date();
                const formattedDate = `${String(currentDate.getDate()).padStart(2, "0")}/${String(
                    currentDate.getMonth() + 1,
                ).padStart(2, "0")}/${currentDate.getFullYear()}`;

                const response = await fetch(`${apiBaseUrl}/savePackageSelection`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });

                if (response.ok) {
                    const destinationNumber = `91${job.whatsapp_number}`;
                    const whatsappPayload = {
                        to: destinationNumber,
                        message: `Dear Employer, ${companyName} ${houseName} (ID: *${employeeId}*), താങ്കളുടെ സ്ഥാപനത്തിൽ ഉള്ള *${
                            job.job
                        }* (Job ID: *${
                            job.manualJobID && job.manualJobID !== "0" ? job.manualJobID : job.job_id
                        }*) ജോലി ഒഴിവിന് www.riyahubs.com വഴി ${formattedDate} തീയതിയിൽ ജോലിക്ക് വേണ്ടിയുള്ള അപേക്ഷ സമർപ്പിച്ചിരിക്കുന്നു.`,
                    };

                    const whatsappResponse = await fetch(`${apiBaseUrl}/send-whatsapp`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(whatsappPayload),
                    });

                    if (whatsappResponse.ok) {
                        alert("Package applied and confirmation sent to WhatsApp.");
                    } else {
                        alert("Job applied Successfully!");
                    }
                }
            } catch (error) {
                console.error("Error:", error);
            }
        } else {
            navigate("/packages", {
                state: {
                    job: job.job,
                    jobId: job.manualJobID && job.manualJobID !== "0" ? job.manualJobID : job.job_id,
                    location: job.location,
                },
            });
        }
        setLoadingJobs((prev) => ({ ...prev, [job.job_id]: false }));
    };

    function formatJobTitle(title) {
        const lowercaseWords = ["at", "in", "of", "for", "to", "and", "on", "by", "with"];
        return title
            .split(" ")
            .map((word, index) =>
                lowercaseWords.includes(word.toLowerCase()) && index !== 0
                    ? word.toLowerCase()
                    : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
            )
            .join(" ");
    }

    return (
        <div className="min-h-screen flex flex-col">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden flex-col border-b-2 border-gray-300">
                <Navbar2 />
                {(customerType === "admin" || customerType === "mainAdmin") && <Navbar3 />}
                {customerType === "employee" && <Navbar4 />}
                {customerType === "candidate" && <Navbar5 />}
            </div>

            <div className="md:hidden flex flex-col ">
                <Navbar2Mob />
                {(customerType === "admin" || customerType === "mainAdmin") && <Navbar3Mob />}
                {customerType === "employee" && <Navbar4Mob />}
                {customerType === "candidate" && <Navbar5Mob />}
            </div>

            {!customerType && (
                <div className="w-full lg:h-[500px] md:h-[900px] h-[700px] bg-[black] flex flex-col pb-3">
                    <div className="w-full h-[20%] flex justify-center items-center px-12 text-[white] lg:text-3xl md:text-3xl sm:text-2xl text-xl font-[600] font-display">
                        Welcome to Riya Hub Jobs - Best Job Portal in India
                    </div>
                    <div className="w-full h-[80%] flex justify-center items-center lg:px-12 px-3 lg:flex-row flex-col gap-5">
                        <div className="lg:w-[50%] w-[100%] lg:h-[340px] md:h-[300px] h-[260px] rounded-[10px] bg-[white] flex flex-row justify-center items-center cursor-pointer">
                            <div className="w-[60%] h-[80%] flex flex-col gap-4 lg:px-12 px-3 justify-start items-start">
                                <span className="lg:text-2xl md:text-2xl text-xl font-[700] font-display">
                                    I am a Candidate
                                </span>
                                <span className="text-base font-[700] font-display">I Want a Job</span>
                                <div
                                    className="h-[42px] lg:w-[50%] w-[50%] bg-[#E22E37] rounded-[5px] flex justify-center items-center lg:text-base text-xs font-[600] font-display text-[white] cursor-pointer hover:bg-black hover:text-white"
                                    onClick={canreg2}
                                >
                                    Free Register
                                </div>
                            </div>
                            <div className="w-[40%] h-full flex justify-center items-end">
                                <img src={girl} alt="girl" />
                            </div>
                        </div>
                        <div className="lg:w-[50%] w-[100%] lg:h-[340px] md:h-[300px] h-[260px] rounded-[10px] bg-[#E22E37] flex flex-row justify-center items-center ">
                            <div className="w-[60%] h-[80%] flex flex-col gap-4 lg:px-12 px-3 justify-start items-start">
                                <span className="lg:text-2xl md:text-2xl text-xl font-[700] font-display text-[white]">
                                    I am an Employer
                                </span>
                                <span className="text-base font-[700] font-display text-[white]">I Want to Hire</span>
                                <div
                                    className="h-[42px] lg:w-[50%] w-[50%] bg-[white] rounded-[5px] flex justify-center items-center lg:text-base text-xs font-[600] font-display cursor-pointer hover:bg-black hover:text-white"
                                    onClick={empreg2}
                                >
                                    Free Job Post
                                </div>
                            </div>
                            <div className="w-[40%] h-full flex justify-center items-end">
                                <img src={india} alt="abroad" />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {customerType && (
                <div className="w-full bg-black text-white py-5 px-4 md:px-8">
                    <div className="max-w-7xl mx-auto text-center">
                        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold font-display tracking-tight">
                            Welcome to Riya Hub Jobs
                        </h1>
                        <p className="mt-2 text-lg md:text-xl text-gray-300 font-medium">Best Job Portal in India</p>
                    </div>
                </div>
            )}

            {/* Search Inputs */}
            {customerType === "candidate" && selectedPlan !== "null" && (
                <div className="bg-gray-100 rounded-[12px] p-5 mt-2 shadow-sm">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <input
                            type="text"
                            placeholder="Search by Job Name..."
                            value={searchTitle}
                            onChange={(e) => setSearchTitle(e.target.value)}
                            className="w-full px-5 py-3 border-2 border-[#C5C5C5] rounded-[10px] focus:outline-none focus:border-[#E22E37]"
                        />
                        <input
                            type="text"
                            placeholder="Search by Location / Address / Area..."
                            value={searchAddress}
                            onChange={(e) => setSearchAddress(e.target.value)}
                            className="w-full px-5 py-3 border-2 border-[#C5C5C5] rounded-[10px] focus:outline-none focus:border-[#E22E37]"
                        />
                    </div>

                    <div className="flex justify-between items-center mt-4 px-4 text-sm text-gray-600">
                        {(searchTitle.trim() || searchAddress.trim()) && (
                            <>
                                <p>
                                    Showing <strong>{jobsToShow.length}</strong> job
                                    {jobsToShow.length !== 1 ? "s" : ""}
                                </p>

                                <button
                                    onClick={() => {
                                        setSearchTitle("");
                                        setSearchAddress("");
                                    }}
                                    className="text-[#E22E37] underline hover:text-red-700 font-medium transition-colors"
                                >
                                    Clear
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* Jobs Section with Dynamic Heading */}
            <div className="flex flex-col w-full lg:px-12 px-3 h-auto gap-12 mt-12 justify-center items-center pb-12 bg-[#FFFFFF]">
                <span className="text-4xl font-[600] font-display">{sectionHeading}</span>

                <div className="grid lg:grid-cols-3 grid-cols-1 w-full gap-3">
                    {jobsToShow.slice(0, visibleJobs).map((job, index) => (
                        <div
                            key={index}
                            className="h-[420px] border-2 border-[#C5C5C5] w-full rounded-[10px] flex flex-col overflow-hidden bg-white"
                        >
                            <div className="w-full h-[20%] bg-white border-b-2 border-[#C5C5C5] flex flex-col justify-center items-center ">
                                <h3 className="text-lg font-[650] text-center line-clamp-2">
                                    {formatJobTitle(job.job_title)}
                                </h3>
                                <div className="flex items-center gap-2">
                                    <img src={vector} alt="location" className="w-4 h-4" />
                                    <span className="text-base font-[500]">{job.location}</span>
                                </div>
                            </div>

                            <div className="w-full h-[80%] flex flex-col bg-white p-4">
                                <div className="flex-1 grid grid-cols-3 gap-x-1 gap-y-0 text-base">
                                    <div className="font-display font-[600] col-span-1 text-left">JOB ID</div>
                                    <div className="font-[500] text-left break-words col-span-2">
                                        : {job.manualJobID && job.manualJobID !== "0" ? job.manualJobID : job.job_id}
                                    </div>

                                    <div className="font-display font-[600] col-span-1 text-left">JOB</div>
                                    <div className="font-[500] text-left break-words col-span-2">: {job.job}</div>

                                    {/* <div className="font-display font-[600] col-span-1 text-left">JOB TYPE</div>
                                    <div className="font-[500] text-left col-span-2">: {job.job_type}</div> */}

                                    <div className="font-display font-[600] col-span-1 text-left">BOYS / GIRLS</div>
                                    <div className="font-[500] text-left col-span-2">
                                        :{" "}
                                        {job.gender_type === "MALE"
                                            ? "BOYS"
                                            : job.gender_type === "FEMALE"
                                              ? "GIRLS"
                                              : job.gender_type === "MALE/FEMALE"
                                                ? "BOYS/GIRLS"
                                                : job.gender_type}
                                    </div>

                                    <div className="font-display font-[600] col-span-1 text-left">Salary</div>
                                    <div className="font-[500] text-left col-span-2">
                                        :{" "}
                                        {job.min_salary > 0 && job.max_salary > 0
                                            ? `${job.min_salary} - ${job.max_salary}`
                                            : job.min_salary > 0
                                              ? job.min_salary
                                              : job.max_salary > 0
                                                ? job.max_salary
                                                : job.salaryType || "Negotiable"}
                                    </div>

                                    <div className="font-display font-[600] col-span-1 text-left">Qualification</div>
                                    <div className="font-[500] text-left col-span-2">
                                        : {job.qualification ? job.qualification : ""}
                                    </div>

                                    {isWithinLast20Days(job.created_at) && (
                                        <>
                                            <div className="font-display font-[600] col-span-1 text-left">Posted</div>
                                            <div className="font-[500] text-left col-span-2">
                                                : {getPostedTimeDisplay(job.created_at)}
                                            </div>
                                        </>
                                    )}

                                    {/* <div className="font-display font-[600] col-span-1 text-left">Posted</div>
                                    <div className="font-[500] text-left col-span-2">
                                        : {getPostedTimeDisplay(job.created_at)}
                                    </div> */}
                                </div>

                                <div className="flex justify-center gap-4 mt-6">
                                    <button
                                        onClick={() =>
                                            details(
                                                job.manualJobID && job.manualJobID !== "0" ? job.manualJobID : job.job_id,
                                            )
                                        }
                                        className="w-[120px] h-[38px] bg-black text-white rounded-[10px] font-[600] hover:bg-[#E22E37] transition-colors"
                                    >
                                        Apply Now
                                    </button>
                                    <button
                                        onClick={() =>
                                            details(
                                                job.manualJobID && job.manualJobID !== "0" ? job.manualJobID : job.job_id,
                                            )
                                        }
                                        className="w-[120px] h-[38px] bg-black text-white rounded-[10px] font-[600] hover:bg-[#E22E37] transition-colors"
                                    >
                                        Job Details
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {visibleJobs < jobsToShow.length && (
                    <div className="flex justify-center mt-4">
                        <button
                            className="bg-[#E22E37] text-white px-4 py-2 rounded-md text-lg font-semibold hover:bg-[#912727]"
                            onClick={loadMoreJobs}
                        >
                            View More
                        </button>
                    </div>
                )}

                <div className="w-full h-[355px] bg-[#E22E37] mt-12 flex flex-row">
                    <div className="lg:w-[60%] w-[100%] lg:items-start items-center lg:justify-start justify-center lg:pl-12 lg:pr-[15%] pl-3 pr-[3%] flex flex-col lg:text-left text-center lg:gap-3 gap-6">
                        <img src={bulb} alt="bulb" className="lg:flex hidden" />
                        <span className="text-3xl font-[700] font-display text-[white]">
                            Discover your ideal career opportunity today.
                        </span>
                        <span className="text-base font-[300] font-display text-white">
                            Unlock your potential with tailored job listings that match your skills and aspirations. Start
                            exploring opportunities that bring you closer to your career goals.
                        </span>
                        <div
                            className="lg:w-[30%] w-[50%] bg-[white] h-[40px] rounded-[5px] justify-center items-center flex text-base font-[700] font-display cursor-pointer hover:bg-black hover:text-white"
                            onClick={regchoose}
                        >
                            Register Now
                        </div>
                    </div>
                    <div className="w-[40%] lg:flex hidden justify-center items-end">
                        <img src={girloffice} alt="girloffice" />
                    </div>
                </div>
            </div>

            <div className="mt-12">
                <Footer />
            </div>
        </div>
    );
}

export default Home;
